<template>
  <div class="tw-flex">
    <div v-for="(option, index) in options" :key="option.value">
      <button
        type="button"
        :ref="option.value + 'button'"
        :class="[
          paddingClass,
          fontSizeClass,
          leadingClass,
          colorClass,
          selectedClass(option.value),
          borderClass(index),
          'tw-shadow-none tw-font-sans tw-inline-flex tw-items-center tw-justify-center tw-transition tw-ease-in-out tw-duration-100 tw-relative',
        ]"
        @click="handleClick(option.value)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "ButtonToggleGroup",
  props: {
    options: Array,
    size: {
      type: String,
      default: "sm",
      validator: (value) => ["xs", "sm", "md", "lg", "xl"].indexOf(value) !== -1,
    },
    disabled: { type: Boolean, default: false },
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      currentSelectionValue: null,
    };
  },
  watch: {
    // Only watch value prop if it's provided
    value: {
      handler(newVal) {
        if (newVal !== null && newVal !== undefined) {
          this.currentSelectionValue = newVal;
        }
      },
      immediate: true,
    },
  },
  computed: {
    paddingClass() {
      switch (this.size) {
        case "xs":
          return "tw-px-2.5 tw-py-1.5";
        case "sm":
          return "tw-px-3 tw-py-2";
        case "md":
        case "lg":
          return "tw-px-4 tw-py-2";
        case "xl":
          return "tw-px-6 tw-py-3";
        default:
          return "";
      }
    },
    fontSizeClass() {
      switch (this.size) {
        case "xs":
          return "tw-text-xs";
        case "sm":
        case "md":
          return "tw-text-sm";
        case "lg":
        case "xl":
          return "tw-text-base";
      }
      return "";
    },
    leadingClass() {
      switch (this.size) {
        case "sm":
          return "tw-leading-4";
      }
      return "";
    },
    colorClass() {
      if (this.disabled) {
        return "tw-border-gray-300 tw-text-gray-500 tw-bg-gray-100 tw-cursor-not-allowed";
      } else {
        return `tw-border-gray-300 tw-bg-white tw-text-gray-600 hover:tw-text-primary-700 focus:tw-outline-none`;
      }
    },
  },
  methods: {
    isSelected(value) {
      return value === this.currentSelectionValue ? true : false;
    },
    selectedClass(value) {
      if (this.isSelected(value) === true) return `tw-text-primary-700 tw-bg-primary-100`;
      else return "";
    },
    borderClass(index) {
      if (index == 0) return "tw-rounded-l tw-border-l tw-border-t tw-border-b";
      else if (index == this.options.length - 1) return "tw-rounded-r tw-border-l-none tw-rounded-l-none tw-border";
      else return "tw-border-t tw-border-b tw-border-l tw-rounded-none";
    },
    handleClick(value) {
      this.currentSelectionValue = value;
      this.$emit("selected", value);
    },
    clearSelection() {
      this.currentSelectionValue = null;
    },
  },
};
</script>
